// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2uMGh","expandIcon":"AccordionButton_expandIcon__1iQk4","expanded":"AccordionButton_expanded__1TTIz"};